import { useState } from "react";

export const useTab = (tabList: string[], initialTab?: string) => {
  const [tab, setTab] = useState(
    initialTab && tabList.includes(initialTab) ? initialTab : tabList[0]
  );
  const handleTab = (tab: string) => {
    setTab(tab);
  };
  return { tab, handleTab, tabList };
};
